import { useState, useRef, useEffect } from "react";

const responses = {
  help: [
    "╔════════════════════════════════════════════╗",
    "║         AVAILABLE COMMANDS                 ║",
    "╠════════════════════════════════════════════╣",
    "║ about      → Show developer bio            ║",
    "║ contact    → Show contact details          ║",
    "║ projects   → Show project quests           ║",
    "║ skills     → Display tech inventory        ║",
    "║ xp         → View experience points        ║",
    "║ clear      → Clear the terminal            ║",
    "║ help       → Show this help message        ║",
    "╚════════════════════════════════════════════╝",
  ],
  about: [
    "════════════════════════════════════════════",
    "👤 PLAYER PROFILE",
    "════════════════════════════════════════════",
    "Name: Pankaj Singh",
    "Class: Full Stack Developer [LEGENDARY]",
    "Alignment: Chaotic Good",
    "Specialty: Functional programming, AI/ML, Web3",
    "Level: 40 | XP: 8+ years",
    "════════════════════════════════════════════",
  ],
  contact: [
    "📧 Email: singh.pankaj@live.com",
    "📱 Phone: +91-745-544-5118",
    "💼 LinkedIn: https://www.linkedin.com/in/pankaj0305/",
    "⚡ GitHub: https://github.com/ps0305",
    "",
    "⚡ Achievement Unlocked: Made Contact!",
  ],
  projects: [
    "════════════════════════════════════════════",
    "🎯 COMPLETED QUESTS",
    "════════════════════════════════════════════",
    "[★★★] H&M MENA - eCommerce Platform",
    "[★★★] Victoria's Secret MENA",
    "[★★☆] Arby's Fast Food (InspireBrand)",
    "[★★☆] Buffalo Wild Wings (InspireBrand)",
    "[★★☆] Sentara Healthcare System",
    "[★★☆] Boots UK eCommerce",
    "[★★☆] Syngenta Smart Engage",
    "════════════════════════════════════════════",
    "Total XP Earned: 12,000+",
  ],
  skills: [
    "════════════════════════════════════════════",
    "🛠️  TECH INVENTORY",
    "════════════════════════════════════════════",
    "[LEGENDARY] React ████████████████ 95%",
    "[LEGENDARY] React Native ████████████████ 95%",
    "[LEGENDARY] TypeScript ███████████████ 88%",
    "[LEGENDARY] Node.js ██████████████ 85%",
    "[EPIC] Angular ████████████ 80%",
    "[EPIC] GraphQL ███████████ 75%",
    "[EPIC] MongoDB ██████████ 70%",
    "════════════════════════════════════════════",
  ],
  xp: [
    "════════════════════════════════════════════",
    "⚡ EXPERIENCE POINTS",
    "════════════════════════════════════════════",
    "Current Level: 40",
    "Total XP: 8,000+ hours",
    "Quests Completed: 20+",
    "Skills Unlocked: 15+",
    "Achievement Points: 250+",
    "",
    "Next Milestone: Senior Architect (Level 50)",
    "════════════════════════════════════════════",
  ],
  konami: [
    "🎮 KONAMI CODE DETECTED! 🎮",
    "════════════════════════════════════════════",
    "⚡ +30 Lives Unlocked!",
    "🏆 Achievement: Old School Gamer",
    "🎯 Secret Quest Activated: Find all Easter Eggs",
    "════════════════════════════════════════════",
    "You've unlocked developer mode. Stay curious!",
  ],
};

const InteractiveTerminal = () => {
  const [history, setHistory] = useState([
    "════════════════════════════════════════════",
    "⚡ TERMINAL v2.0 - DEVELOPER CONSOLE ACTIVE",
    "════════════════════════════════════════════",
    "Type 'help' to view available commands.",
    "Try 'konami' for a surprise... 🎮",
    "",
  ]);
  const [input, setInput] = useState("");
  const terminalRef = useRef(null);

  useEffect(() => {
    terminalRef.current?.scrollTo(0, terminalRef.current.scrollHeight);
  }, [history]);

  const handleCommand = (command) => {
    if (command === "clear") {
      setHistory([]);
      return;
    }

    const output = responses[command.toLowerCase()];
    if (output) {
      setHistory((prev) => [...prev, `> ${command}`, ...output]);
    } else {
      setHistory((prev) => [
        ...prev,
        `> ${command}`,
        "Error: Command not found. Type 'help' for a list of commands.",
      ]);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!input.trim()) return;
    handleCommand(input.trim());
    setInput("");
  };

  return (
    <div className="relative border border-emerald-500/50 text-slate-100 p-4 rounded font-mono shadow-[0_0_18px_rgba(16,185,129,0.2)] max-w-3xl mx-auto h-[500px] flex flex-col bg-slate-950/70 backdrop-blur-sm">
      <div
        className="flex-1 overflow-y-auto pb-4"
        ref={terminalRef}
      >
        {history.map((line, idx) => (
          <div key={idx} className="whitespace-pre-wrap text-slate-200/90">{line}</div>
        ))}
      </div>
      <form onSubmit={handleSubmit} className="flex items-center mt-2">
        <span className="text-emerald-400">&gt;</span>
        <input
          autoFocus
          type="text"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          className="bg-transparent outline-none border-none text-slate-100 w-full ml-2 placeholder-slate-500"
          placeholder="Enter command..."
        />
      </form>
    </div>
  );
};

export default InteractiveTerminal;
